<style scoped lang="scss">
.header_bar {
    width: 100%;
    padding-top: 20px;
    padding-top: calc(20px + constant(safe-area-inset-bottom)); /* 兼容 iOS < 11.2 */
    padding-top: calc(20px + env(safe-area-inset-bottom)); /* 兼容 iOS >= 11.2 */
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    padding-left: 15px;
    padding-right: 15px;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background-color: #fff;
    z-index: 999;
    overflow: hidden;

    .back {
        width: 40px;
        height: 44px;
        display: flex;
        align-items: center;

        img {
            width: 11px;
            height: 20px;
        }
    }

    .title {
        flex: 1;
        height: 44px;
        font-size: 18px;
        color: #333;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 26px;
            height: 26px;
            padding-right: 5px;
        }
    }

    .service {
        width: 40px;
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        img {
            width: 20px;
            height: 20px;
        }
    }
}
</style>

<template>
    <div class="header_bar">
        <div class="back" @click="backClick" v-if="backShow">
            <img src="/static/images/works/store_button_back_pressed_2x.png" alt>
        </div>

        <div class="title">
            <div>{{ title }}</div>
        </div>

        <div class="service" @click="clickOpenService">
            <img v-if="serviceShow" class="service_image" src="/static/images/works/h5_icon_service.png">
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: true
        },
        backShow: {
            type: Boolean,
            default: true
        },
        serviceShow: {
            type: Boolean,
            default: false
        },
    },

    created() {
    },

    methods: {
        // 返回上一页
        backClick() {
            this.$emit("back", true);
        },

        // 客服咨询
        clickOpenService() {
            let ua = JSON.parse(navigator.userAgent)
            let device = ua.device.toLowerCase()

            if (device.includes('iphone')) {
                window.webkit.messageHandlers.AppModel.postMessage({
                    body: "openService",
                    isAlert: "false"
                })
            } else if (device.includes('android')) {
                window.nativeMethod.openService()
            }
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/headerBar.vue